module.exports = __webpack_public_path__ + "sq19-7203acf6.png";